export enum ItemType {
  EVENT = "event",
  RACE = "race",
  }
  